import { ActionIcon, Grid, TextInput } from "@mantine/core";
import { AiOutlineSearch } from "react-icons/ai";
import { useEffect, useState } from "react";
import { useDebouncedValue } from '@mantine/hooks';
import "./SearchBar.css";

export default function SearchBar({ 
  onSearch, 
  placeholder = "Search...",
  className = "",
  debounceDelay = 200 // 200ms default delay to match docs
}) {
  const [value, setValue] = useState("");
  const [debounced] = useDebouncedValue(value, debounceDelay);

  // Call onSearch whenever debounced value changes
  useEffect(() => {
    onSearch(debounced);
  }, [debounced, onSearch]);

  const handleKeyPress = (event) => {
    if (event.key === "Enter") {
      onSearch(value); // Immediate search on Enter
    }
  };

  const handleSearchClick = () => {
    onSearch(value); // Immediate search on button click
  };

  return (
    <Grid align="center" className={`search-bar ${className}`} gutter={0}>
      <Grid.Col span="auto">
        <TextInput
          value={value}
          onChange={(event) => setValue(event.currentTarget.value)}
          onKeyDown={handleKeyPress}
          placeholder={placeholder}
          radius="8px 0px 0px 8px"
          styles={{
            input: {
              '&:focus': {
                borderColor: '#228be6',
              },
            },
          }}
        />
      </Grid.Col>
      <Grid.Col span="content">
        <ActionIcon
          onClick={handleSearchClick}
          radius="0px 8px 8px 0px"
          variant="subtle"
        >
          <AiOutlineSearch size="1.2rem" />
        </ActionIcon>
      </Grid.Col>
    </Grid>
  );
} 